import { render, staticRenderFns } from "./project-basics.vue?vue&type=template&id=23517c07&scoped=true&"
import script from "./project-basics.vue?vue&type=script&lang=js&"
export * from "./project-basics.vue?vue&type=script&lang=js&"
import style0 from "./project-basics.vue?vue&type=style&index=0&id=23517c07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23517c07",
  null
  
)

export default component.exports